import React from 'react';
import { useTranslation } from '../context/AppContext';

export default function Features() {
    const { t } = useTranslation(); // ✅ Только useTranslation

  return (
    <section className="py-16 px-6 bg-white">
      <div className="max-w-5xl mx-auto text-center">
        <h2 className="text-3xl font-bold mb-12">{t.why}</h2>
        <div className="grid md:grid-cols-3 gap-10">
          <div className="p-6 bg-gray-50 rounded-xl shadow-sm hover:shadow-md transition">
            <h3 className="text-xl font-semibold mb-3">🎧 {t.feature1}</h3>
            <p className="text-gray-600">{t.feature1Desc}</p>
          </div>
          <div className="p-6 bg-gray-50 rounded-xl shadow-sm hover:shadow-md transition">
            <h3 className="text-xl font-semibold mb-3">🌐 {t.feature2}</h3>
            <p className="text-gray-600">{t.feature2Desc}</p>
          </div>
          <div className="p-6 bg-gray-50 rounded-xl shadow-sm hover:shadow-md transition">
            <h3 className="text-xl font-semibold mb-3">📱 {t.feature3}</h3>
            <p className="text-gray-600">{t.feature3Desc}</p>
          </div>
        </div>
      </div>
    </section>
  );
}